import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setStatsigInitialization } from "../shared/ab-experiment/actions";
import { getRefreshTokenInfo, getSeoList, getUserLocationSuccess, logoutSuccess, openSecondaryIdentifierModal, setBifrostTokens, setCurrentScreen, setGAId, setPrimaryIdentifierType, setProfileWithToken, setSecureToken, updateIsFirstUserSession, verifySignIn } from "./actions";
import AUConfiguration from "./component";
import { setModalContentSeen, updateNudgeCountSyncStatus, updateSupportWidgetConfig } from "../au.mobile/support-widget/actions";
import { fetchSearchResult } from "../au.mobile/filters/actions";
import { setRecentlyViewedData } from "../au.desktop/filters/actions";
import { reloadCarDetails as reloadCarDetailsMobile } from "../au.mobile/car-details/actions";
import { reloadCarDetails as reloadCarDetailsDesktop } from "../au.desktop/car-details/actions";
import { reloadCarList as realoadCarListMobile } from "../au.mobile/car-listing/actions";
import { reloadCarList as realoadCarListDesktop } from "../au.desktop/car-listing/actions";

const mapStateToProps = ({
    user: {seoMenu, firstName, middleName, lastName, email, mobile, isLoggedIn, loginType, userId, gaId, isUmsProfileFetched, primaryIdentifierType, umsUserId, profileName},
    abExperiment,
    abExperiment: { msiteBi2ph, preApprovalOnFlyDesktop, preApprovalOnFlyMsite, statsigConfig}
}) => ({
    seoMenu,
    firstName,
    middleName,
    lastName,
    email,
    mobile,
    isLoggedIn,
    loginType,
    userId,
    abExperiment,
    gaId,
    msiteBi2ph,
    preApprovalOnFlyDesktop,
    preApprovalOnFlyMsite,
    statsigConfig,
    isUmsProfileFetched,
    primaryIdentifierType,
    umsUserId,
    profileName
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getRefreshTokenInfoConnect: getRefreshTokenInfo,
    logoutSuccessConnect: logoutSuccess,
    setSecureTokenConnect: setSecureToken,
    setGAIdConnect: setGAId,
    getSeoListConnect: getSeoList,
    setCurrentScreenConnect: setCurrentScreen,
    updateIsFirstUserSessionConnect: updateIsFirstUserSession,
    updateSupportWidgetConfigConnect: updateSupportWidgetConfig,
    setModalContentSeenConnect: setModalContentSeen,
    updateNudgeCountSyncStatusConnect: updateNudgeCountSyncStatus,
    setStatsigInitializationConnect: setStatsigInitialization,
    setRecentlyViewedDataConnect: setRecentlyViewedData,
    fetchSearchResultConnect: fetchSearchResult,
    verifySignInConnect: verifySignIn,
    reloadCarDetailsMobileConnect: reloadCarDetailsMobile,
    reloadCarDetailsDesktopConnect: reloadCarDetailsDesktop,
    reloadCarListMobileConnect: realoadCarListMobile,
    reloadCarListDesktopConnect: realoadCarListDesktop,
    setLocationSuccessConnect: getUserLocationSuccess,
    setBifrostTokensConnect: setBifrostTokens,
    setProfileWithTokenConnect: setProfileWithToken,
    setPrimaryIdentifierTypeConnect: setPrimaryIdentifierType,
    openSecondaryIdentifierModalConnect: openSecondaryIdentifierModal
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AUConfiguration);
